import React from "react"

import FieldEventStartEnd_GlistView from "./render/glist-view"
import FieldDateRange from "../../../generic/datetime/date-range/date-range"
import FieldConfig from "../../../proto/field-config"
import Event from "../../../../model2/event/event"
import ItemModelV2 from "../../../../model2/item2/item-model"
import TasksViewManager from "../../../../gd-modules/tasks-view/core/manager"
import GanttManager from "../../../../gd-modules/gantt-chart/manager/manager"
import {ViewType} from "../../../../gd/const/views/view-type"
import {EventType} from "../../../../gd/const/event"
import FieldEventStartEnd_TableCell from "./render/table/table-cell"
import FieldEventStartEnd_Popover from "./components/popover/popover"
import FieldProto_updateView from "../../../proto/render/table/function/update-view"

export default class FieldEventStartEnd extends FieldDateRange {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                  = "Start/End"
        this.icon                       = 'i5-calendar'
        this.label                      = "Start/End"

        this.clearButton                = _.get(config,'clearButton',true);

        this.components.ValueIcon       = <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>
        this.components.PopoverMenu     = FieldEventStartEnd_Popover

        this.renderComponents.glistView = FieldEventStartEnd_GlistView
        this.renderComponents.tableCell = FieldEventStartEnd_TableCell

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    canEdit(model:Event):boolean {
        return model.acl.canChangeStartDate
    }

    getViewValue(model:any) {
        switch (model.type) {
            case EventType.PROJECT_MILESTONE:
                return model['startDate']

            default:
                return model[this.fieldId] ? model[this.fieldId] : model['startDate']
        }
    }

    // normalize value for sorting
    sortValue(value:any, model:any) {
        return value ? value.start ? value.start.format('x') : value.format('x') : 0;
    }

    tableCellOnValueChange = async (item: ItemModelV2, value: MomentRange|Moment|null, manager: TasksViewManager|GanttManager) => {

        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:

                const ganttManager = manager as GanttManager

                switch (item.event.type) {
                    case EventType.PROJECT_MILESTONE:
                        ganttManager.setStartEnd(item.id, value, null)
                        break

                    default                                     :
                        const newStartDate  = value ? (value as MomentRange).start : null
                        const newEndDate    = value ? (value as MomentRange).end : null
                        ganttManager.setStartEnd(item.id, newStartDate, newEndDate)
                        break
                }
                break

            default:
                switch (item.event.type) {
                    case EventType.PROJECT_MILESTONE:
                        if (!value) {
                            // jsut start is enough
                            item.event.updateStartDate(null)
                        } else {
                            item.event.updateStartDate(value as Moment)
                        }
                        break

                    default                                     :
                        if (!value) {
                            // just start is enough
                            item.event.updateStartDate(null)
                        } else {
                            item.event.updateStartDate((value as MomentRange).start)
                            item.event.updateEndDate((value as MomentRange).end)
                        }
                        break
                }

                item.event.save()

                item.updateLastUpdateTime() // otherwise it wont re-render

                FieldProto_updateView(manager as TasksViewManager, this)
                break
        }

    }
}